import { primaryColors } from "../constant";
import {getStoreName} from "../utils/index"
export const getColor = (type) => {
  const keyName = getStoreName();
  if (primaryColors[keyName]) {
    switch (type) {
      case "main":
        return primaryColors[keyName][0];
      case "mainLight":
        return primaryColors[keyName][1];
      case "shoppingCartLabel":
        return primaryColors[keyName][2];
      case "buttonText":
        return primaryColors[keyName][3];
      default:
        return primaryColors[keyName][0];
    }
  } else {
    switch (type) {
      case "main":
        return "#ffd258";
      case "mainLight":
        return "#ffd2583d";
      case "shoppingCartLabel":
        return "#ffd258";
      case "buttonText":
        return "#ffffff";
      default:
        return "#ffd2583d";
    }
  }
};
